import { render, staticRenderFns } from "./porposal-report-evaluation-detail.vue?vue&type=template&id=24159044&scoped=true&"
import script from "./porposal-report-evaluation-detail.vue?vue&type=script&lang=ts&"
export * from "./porposal-report-evaluation-detail.vue?vue&type=script&lang=ts&"
import style0 from "./porposal-report-evaluation-detail.vue?vue&type=style&index=0&id=24159044&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24159044",
  null
  
)

export default component.exports